import { render, staticRenderFns } from "./ApprovalTableBase.vue?vue&type=template&id=1f3b5c64"
import script from "./ApprovalTableBase.vue?vue&type=script&lang=ts"
export * from "./ApprovalTableBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports